import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  HStack,
  Input,
  Text,
  VStack,
  Checkbox,
  Select,
} from "@chakra-ui/react";
import React from "react";
import { useAuth } from "../../providers/AuthProvider";
import axios from "axios";
import { url } from "../../config";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import moment from "moment";
import StatusChip from "../utils/StatusChip";

export default function Overview() {
  const { token } = useAuth();

  const [filteredData, setFilteredData] = React.useState([]);
  const [isSetToShowAll, setIsSetToShowAll] = React.useState(true);
  const [statusFilter, setStatusFilter] = React.useState("all");

  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    let result = data;
    if (!isSetToShowAll) {
      result = result.filter((c) => c.paid_by_user == "0");
    }
    if (statusFilter !== "all") {
      result = result.filter(
        (c) => c.status && c.status.toLowerCase() === statusFilter,
      );
    }
    setFilteredData(result);
  }, [data, isSetToShowAll, statusFilter]);

  function getReportData() {
    setLoading(true);
    // fetch report data
    axios
      .get(`${url}/overview`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching report data:", error);
        // alert('Failed to fetch report data');
        toast.error("Failed to fetch report data");
      });
  }

  React.useEffect(() => {
    getReportData();
  }, []);

  const exportToCSV = () => {
    if (!filteredData || filteredData.length === 0) {
      toast.error("No data to export");
      return;
    }

    const headers = Object.keys(filteredData[0]);
    const csvRows = [];

    csvRows.push(headers.join(","));

    for (const row of filteredData) {
      const values = headers.map((header) => {
        let val = row[header];
        if (val === null || val === undefined) {
          return '""';
        }
        val = String(val);
        val = val.replace(/"/g, '""');
        return `"${val}"`;
      });
      csvRows.push(values.join(","));
    }

    const csvString = csvRows.join("\n");
    const blob = new Blob([csvString], { type: "text/csv" });
    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", urlBlob);
    a.setAttribute(
      "download",
      `Overview_Export_${moment().format("YYYY-MM-DD")}.csv`,
    );
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <Container maxW="9xl" my="6">
      <VStack width="100%" spacing={4}>
        <Card borderRadius="md" p="4" width={"100%"}>
          <HStack justifyContent="space-between" w="100%">
            <Text fontWeight="600" className="customfont" fontSize="2xl">
              Overview
            </Text>
            {!loading && data !== null && data.length > 0 && (
              <HStack w="100%">
                <Card
                  p="3"
                  bg={isSetToShowAll ? "green.200" : "white"}
                  onClick={() => setIsSetToShowAll(true)}
                  cursor="pointer"
                >
                  <HStack>
                    <Text>Show All</Text>
                    <Checkbox colorScheme="green" isChecked={isSetToShowAll} />
                  </HStack>
                </Card>
                <Card
                  p="3"
                  bg={isSetToShowAll ? "white" : "green.200"}
                  onClick={() => setIsSetToShowAll(false)}
                  cursor="pointer"
                >
                  <HStack>
                    <Text>Show Pending Only</Text>
                    <Checkbox colorScheme="green" isChecked={!isSetToShowAll} />
                  </HStack>
                </Card>
                <Select
                  bg="white"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  w="200px"
                >
                  <option value="all">All Statuses</option>
                  <option value="active">Active</option>
                  <option value="redeemed">Redeemed</option>
                  <option value="cancelled">Cancelled</option>
                </Select>
                <Button colorScheme="blue" onClick={exportToCSV}>
                  Export CSV
                </Button>
              </HStack>
            )}
          </HStack>
        </Card>

        {!loading && data !== null && data.length > 0 && (
          <Card width={"100%"} overflow="auto">
            <Text p="4" fontWeight="600" className="customfont" fontSize="lg">
              Payments
            </Text>

            <table>
              <thead>
                <tr>
                  <th style={{ fontSize: "14px" }}>Id</th>
                  <th style={{ fontSize: "14px" }}>Scheme</th>
                  <th style={{ fontSize: "14px" }}>Amount</th>
                  <th style={{ fontSize: "14px" }}>Term</th>
                  <th style={{ fontSize: "14px" }}>Name</th>
                  <th style={{ fontSize: "14px" }}>Number</th>
                  <th style={{ fontSize: "14px" }}>Email</th>
                  <th style={{ fontSize: "14px" }}>Actual Payment Date</th>
                  <th style={{ fontSize: "14px" }}>User Payment Date</th>
                  <th style={{ fontSize: "14px" }}>Store Accepted Date</th>
                  <th style={{ fontSize: "14px" }}>User Paid</th>
                  <th style={{ fontSize: "14px" }}>Store Accepted</th>
                  <th style={{ fontSize: "14px" }}>Store</th>
                  <th style={{ fontSize: "14px" }}>Status</th>
                  <th style={{ fontSize: "14px" }}>Enrollment Date</th>
                </tr>
              </thead>

              <tbody>
                {/* {pending.map((u, idx) => { */}
                {filteredData.map((u, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{u.id_number}</td>
                      <td>{u.scheme_name}</td>
                      <td>{u.amount}</td>
                      <td>{u.term}</td>
                      <td>{u.name}</td>
                      <td>{u.phone}</td>
                      <td>{u.e_mail}</td>
                      <td style={{ width: "140px" }}>
                        {" "}
                        {moment(u.payment_date).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ width: "140px" }}>
                        {" "}
                        {u.user_payment_date == null
                          ? "-"
                          : moment(u.user_payment_date).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ width: "140px" }}>
                        {" "}
                        {u.store_payment_date == null
                          ? "-"
                          : moment(u.store_payment_date).format("DD-MM-YYYY")}
                      </td>
                      <td>
                        {" "}
                        {u.paid_by_user == "1" ? (
                          <Box bg="green.200" p="2" borderRadius="md">
                            <Text>YES</Text>
                          </Box>
                        ) : (
                          <Box bg="red.200" p="2" borderRadius="md">
                            <Text>NO</Text>
                          </Box>
                        )}
                      </td>
                      <td>
                        {" "}
                        {u.accepted_by_store == "1" ? (
                          <Box bg="green.200" p="2" borderRadius="md">
                            <Text>YES</Text>
                          </Box>
                        ) : (
                          <Box bg="red.200" p="2" borderRadius="md">
                            <Text>NO</Text>
                          </Box>
                        )}
                      </td>
                      <td> {u.branch}</td>
                      <td>
                        {" "}
                        <StatusChip status={u.status} />
                      </td>
                      <td style={{ width: "140px" }}>
                        {" "}
                        {moment(u.enrollment_date).format("DD-MM-YYYY")}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        )}
      </VStack>
    </Container>
  );
}
